import axios from "axios";
import React, { useContext, useEffect, useReducer } from "react";
import reducer from "../reducers/registrations_groups_reducer";
import { divisions_url } from "../utils/constants";
import {
  REG_GRP_LOADING_IN_PROGRESS,
  REG_GRP_LOADING_ERROR,
  REG_GRP_LOADING_COMPLETED,
  REG_GRP_UPDATED,
} from "../actions";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

const initialState = {
  season: 5,
  regGroups: [],
  regGroupInProgress: false,
  regGroupError: false,
  regGroupCompleted: false,
};

const RegistrationGroupsContext = React.createContext();

export const RegistrationGroupsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchRegGroups = async () => {
    const url = divisions_url + state.season;
    dispatch({ type: REG_GRP_LOADING_IN_PROGRESS });

    try {
      const response = await axios.get(url);
      const regGroups = response.data;

      dispatch({ type: REG_GRP_LOADING_COMPLETED, payload: regGroups });
    } catch (error) {
      dispatch({ type: REG_GRP_LOADING_ERROR });
    }
  };

  const updateRegGroup = (regGroup) => {
    dispatch({ type: REG_GRP_UPDATED, payload: { regGroup: regGroup } });
  };

  useEffect(() => {
    fetchRegGroups();
    // eslint-disable-next-line
  }, []);

  return (
    <RegistrationGroupsContext.Provider
      value={{ ...state, updateRegGroup, fetchRegGroups }}
    >
      {children}
    </RegistrationGroupsContext.Provider>
  );
};
// make sure use
export const useRegistrationGroupsContext = () => {
  return useContext(RegistrationGroupsContext);
};
